import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/useAuthStore';
import { useInstagramStore } from '../stores/useInstagramStore';
import { checkIfUserBanned } from '../utils/bannedUserCheck';

interface BannedUserCheckerProps {
    children: React.ReactNode;
}

export const BannedUserChecker: React.FC<BannedUserCheckerProps> = ({ children }) => {
    const { user } = useAuthStore();
    const { connectedProfile } = useInstagramStore();
    const [isChecking, setIsChecking] = useState(true);
    const [isBanned, setIsBanned] = useState(false);

    useEffect(() => {
        const checkBannedStatus = async () => {
            if (!user) {
                setIsChecking(false);
                return;
            }

            // 전화번호 형식 변환
            let formattedPhone = user.phone;
            if (formattedPhone) {
                if (formattedPhone.startsWith('+')) {
                    formattedPhone = formattedPhone.substring(1);
                }
            }

            // 인스타그램 username 가져오기
            const instagramUsername = connectedProfile?.username || null;

            // 차단 확인
            const banned = await checkIfUserBanned(formattedPhone, instagramUsername);

            if (banned) {
                console.log('🚫 차단된 사용자가 VIP/가계정 분석 접근 시도');
                setIsBanned(true);
            }

            setIsChecking(false);
        };

        checkBannedStatus();
    }, [user, connectedProfile]);

    // 차단된 사용자는 무한 로딩 페이지로
    if (isBanned) {
        return <Navigate to="/infinite-loading" replace />;
    }

    // 확인 중이면 로딩 표시
    if (isChecking) {
        return (
            <div className="min-h-screen bg-black flex items-center justify-center">
                <div className="w-16 h-16 border-4 border-purple-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
        );
    }

    // 차단되지 않은 사용자는 정상 페이지 표시
    return <>{children}</>;
};

export default BannedUserChecker;